module.exports = __webpack_public_path__ + "static/img/CZ_H5.526fd1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/CZ_H5.png
// module id = 3ElF
// module chunks = 34